var _g;

var _excluded = ["title", "titleId"];

function _extends() { _extends = Object.assign ? Object.assign.bind() : function (target) { for (var i = 1; i < arguments.length; i++) { var source = arguments[i]; for (var key in source) { if (Object.prototype.hasOwnProperty.call(source, key)) { target[key] = source[key]; } } } return target; }; return _extends.apply(this, arguments); }

function _objectWithoutProperties(source, excluded) { if (source == null) return {}; var target = _objectWithoutPropertiesLoose(source, excluded); var key, i; if (Object.getOwnPropertySymbols) { var sourceSymbolKeys = Object.getOwnPropertySymbols(source); for (i = 0; i < sourceSymbolKeys.length; i++) { key = sourceSymbolKeys[i]; if (excluded.indexOf(key) >= 0) continue; if (!Object.prototype.propertyIsEnumerable.call(source, key)) continue; target[key] = source[key]; } } return target; }

function _objectWithoutPropertiesLoose(source, excluded) { if (source == null) return {}; var target = {}; var sourceKeys = Object.keys(source); var key, i; for (i = 0; i < sourceKeys.length; i++) { key = sourceKeys[i]; if (excluded.indexOf(key) >= 0) continue; target[key] = source[key]; } return target; }

import * as React from "react";

function SvgRefresh(_ref, svgRef) {
  var title = _ref.title,
      titleId = _ref.titleId,
      props = _objectWithoutProperties(_ref, _excluded);

  return /*#__PURE__*/React.createElement("svg", _extends({
    id: "noun_Refresh_3344616",
    xmlns: "http://www.w3.org/2000/svg",
    width: 16,
    height: 16,
    viewBox: "0 0 16 16",
    ref: svgRef,
    "aria-labelledby": titleId
  }, props), title ? /*#__PURE__*/React.createElement("title", {
    id: titleId
  }, title) : null, _g || (_g = /*#__PURE__*/React.createElement("g", {
    id: "Group_7978",
    "data-name": "Group 7978"
  }, /*#__PURE__*/React.createElement("path", {
    id: "Path_6022",
    "data-name": "Path 6022",
    d: "M15.328,7.328A.672.672,0,0,0,14.657,8a6.657,6.657,0,1,1-2.784-5.414h-.887a.672.672,0,1,0,0,1.343h2.586a.672.672,0,0,0,.672-.672V.672a.672.672,0,1,0-1.343,0V1.677A8,8,0,1,0,16,8,.672.672,0,0,0,15.328,7.328Z",
    fill: "#203662"
  }))));
}

var ForwardRef = /*#__PURE__*/React.forwardRef(SvgRefresh);
export default __webpack_public_path__ + "static/media/Refresh.1d636a460e9de7b6844a40d55e240409.svg";
export { ForwardRef as ReactComponent };